function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
}
class BaseTypeRef {
    toString() {
        return `${this.kind}Ref<${this.name}>`;
    }
    constructor(kind, name) {
        _define_property(this, "kind", void 0);
        _define_property(this, "name", void 0);
        this.kind = kind;
        this.name = name;
    }
}
export { BaseTypeRef as default };
//# sourceMappingURL=base.js.map
